/** PictPath からファイル名のみ取得 */
function pictFileName(pictPath) {
  const p = String(pictPath || "").replace(/^\/+/, "");
  const idx = p.lastIndexOf("/");
  return idx >= 0 ? p.slice(idx + 1) : p;
}

/** サムネイル/原寸のファイル名に変換 */
function toThumbnailFileName(fileName) {
  return String(fileName || "").replace(/\.(jpg|jpeg|png|gif)$/i, "_s.$1");
}

function toFullFileName(fileName) {
  return String(fileName || "").replace(/_s\.(jpg|jpeg|png|gif)$/i, ".$1");
}

/**
 * 依頼写真の S3 オブジェクトキーを組み立てる
 * PictPath がファイル名のみ / images/ から始まるフルパスのどちらにも対応
 */
export function buildRequestPictS3Key(pictPath, corpId, mitsumoriNo, { thumbnail = false } = {}) {
  const raw = String(pictPath || "").replace(/^\/+/, "");
  if (raw.startsWith("images/")) {
    const fileName = pictFileName(raw);
    const name = thumbnail ? toThumbnailFileName(fileName) : toFullFileName(fileName);
    const dir = raw.slice(0, raw.lastIndexOf("/") + 1);
    return `${dir}${name}`;
  }

  const fileName = pictFileName(raw);
  const name = thumbnail ? toThumbnailFileName(fileName) : toFullFileName(fileName);
  return `images/${corpId}/${mitsumoriNo}/${name}`;
}

/** 依頼写真の S3 URL を組み立てる */
export function buildRequestPictUrl(s3Base, pictPath, corpId, mitsumoriNo, options = {}) {
  const base = String(s3Base || "").replace(/\/$/, "");
  const key = buildRequestPictS3Key(pictPath, corpId, mitsumoriNo, options);
  return `${base}/${key}`;
}
